<template>
  <header
    v-if="headerConfig"
    class="l-hd fixed left-0 top-0 z-[10] w-full"
    :class="{
      'z-[11]': commonStore.loading,
    }"
  >
    <div
      class="m-hd relative mx-auto flex h-[74px] max-w-[600px] items-center justify-center bg-[var(--bg-header)]"
    >
      <div id="header-left" class="absolute left-[16px]"></div>
      <figure class="relative z-[1] bg-[var(--bg-header)] p-[5px]">
        <img
          :src="headerConfig.logoUrl"
          class="m-hd-logo"
          :alt="config.title"
        />
      </figure>
      <ul
        class="absolute right-[16px] flex items-center justify-center space-x-[16px]"
      >
        <li v-if="shareConfig && shareBtn">
          <button
            type="button"
            class="relative z-[1] flex h-[30px] w-[30px] shrink-0 items-center justify-center bg-[var(--bg-header)]"
            @click="socialLink"
          >
            <SvgIcon icon-class="share" class="mr-[2px] h-[24px] w-[24px]" />
          </button>
        </li>
        <li v-if="config?.showTicketButton">
          <router-link
            :to="{
              name: 'Ticket',
            }"
            class="relative z-[1] flex h-[30px] w-[30px] shrink-0 items-center justify-center bg-[var(--bg-header)]"
          >
            <SvgIcon icon-class="ticket" class="mr-[2px] h-[24px] w-[24px]" />
          </router-link>
        </li>
      </ul>
    </div>
    <ModalBox
      v-model:open="modal.socialLink"
      width="w-[315px]"
      :closeBtn="true"
      v-if="shareConfig && shareBtn"
    >
      <div
        class="relative bg-[var(--bg-body)] px-[25px] pb-[25px] pt-[90px] text-center"
      >
        <figure class="absolute left-[50%] top-0 translate-x-[-50%]">
          <img
            :src="shareConfig.backgroundUrl"
            class="h-[80px] w-[130px]"
            :alt="config.title"
          />
        </figure>
        <p class="mb-[14px] text-[20px] tracking-[0.3em]">請選擇分享方式</p>
        <div class="mt-[20px] text-center">
          <ul class="space-y-[14px]">
            <li>
              <button
                type="button"
                class="m-btn-grad flex h-[43px] w-[255px] items-center justify-center"
                @click="shareFb"
              >
                <SvgIcon
                  icon-class="facebook"
                  class="mr-[10px] h-[18px] w-[18px]"
                />
                <p class="text-[16px]">分享至 Facebook</p>
              </button>
            </li>
            <li v-if="liffStore.isLiffInit">
              <button
                type="button"
                class="m-btn-grad flex h-[43px] w-[255px] items-center justify-center"
                @click="shareLiff"
              >
                <SvgIcon
                  icon-class="line"
                  class="mr-[10px] h-[18px] w-[18px]"
                />
                <p class="text-[16px]">分享給 LINE 好友</p>
              </button>
            </li>
            <li>
              <button
                type="button"
                class="m-btn-grad flex h-[43px] w-[255px] items-center justify-center"
                @click="copyHref"
              >
                <SvgIcon
                  icon-class="linking"
                  class="mr-[10px] h-[18px] w-[18px]"
                />
                <p class="text-[16px]">複製活動連結</p>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </ModalBox>
  </header>
</template>

<script setup>
import { useRoute } from 'vue-router'

import { useCommonStore } from '@/store/common'
import { useLiffStore } from '@/store/liff'
import useModal from '@/components/Modal/useModal'
import { computed } from 'vue'

import { useLayoutConfig } from '@/composables/useLayoutConfig'

const { config } = useLayoutConfig()

const headerConfig = computed(() => {
  if (!config.value?.header) return {}
  return config.value.header
})


const shareConfig = computed(() => {
  if (!headerConfig.value?.share) return false
  return headerConfig.value.share
})

const commonStore = useCommonStore()
const liffStore = useLiffStore()

const route = useRoute()

const { modal, modalClose } = useModal({
  socialLink: false,
})

function socialLink() {
  modal.socialLink = true
}

const shareBtn = computed(() => route?.meta?.shareBtn && route.params?.id)

function shareFb() {
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(liffStore.liffShareData.ShareLink)}`

  console.log('shareUrl', shareUrl)
  window.open(shareUrl, '_blank')
}

async function shareLiff() {
  const res = await liffStore.liffShare()

  if (res) {
    modalClose()
  }
}

async function copyHref() {
  navigator.clipboard.writeText(liffStore.liffShareData.ShareLink)
  alert('連結已複製')
}
</script>

<style lang="postcss">
.m-hd {
  z-index: 2;

  &:before,
  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    left: 0;
    width: 100%;
    pointer-events: none;
  }

  &::before {
    height: 100%;
    opacity: 0.6;
    background-size: 100% auto;
  }

  &:after {
    height: 4px;
    bottom: 0;
    /* background: var(--gradient-header-border); */
  }
}

.m-btn-grad {
  border: 10px solid;
  border-image-slice: 1;
  border-width: 1px;
  border-image-source: linear-gradient(140deg, #9a774f 0%, #000000 100%);
}

.dalmore {
  .m-hd {
    &:before {
      background: url(@/assets/img/dalmore/header-bg.svg);
      background-size: 100% auto;
    }
    &::after {
      background: linear-gradient(90deg, #daa963 0%, #fde4c0 52.6%, #dab075 100%);
    }
  }

  .m-hd-logo {
    width: 122px;
    height: 36px;
  }
}

.jura {
  .m-hd {
    &:before {
      background: url(@/assets/img/jura/header-bg.png);
      background-size: 100% auto;
    }
    &::after {
      background: linear-gradient(90deg, #daa963 0%, #fde4c0 52.6%, #dab075 100%);
    }
  }

  
  .m-hd-logo {
    width: 122px;
    height: 36px;
  }
}

.fettercairn {  
  .m-hd {
    &:before {
      background: #00AAA1;
    }
    &::after {
      background: url(@/assets/img/fettercairn/hearder-border.png);
      background-size: 100% auto;
    }
  }


  .m-hd-logo {
    width: 180px;
    height: 60px;
  }
}

.tamnavulin {
  .m-hd {
    &::after {
      background: #CEB895;
    }
  }

  .m-hd-logo {
    width: 78px;
    height: 51px;
  }
}
</style>
